import $ from "jquery";
import Drupal from "Drupal";
import drupalSettings from "drupalSettings";

(function ($, Drupal, drupalSettings) {
  "use strict";

  Drupal.behaviors.prlistingform = {

    setprlistingdatefilters:function(form){
        var year = $(form).find('[name=year_select]').val();
        var minmonth = $(form).find('[name=month_select]').val();
        var maxmonth = $(form).find('[name=month_select]').val();

        if(year != 'all')
        {
            if(minmonth == 'all')
            {
                minmonth = '01';
            }
            if(maxmonth == 'all')
            {
                maxmonth = '12';
            }

            var minddate = year + '-' + minmonth + '-' + '01';
            var maxddate = year + '-' + maxmonth + '-' + '31';

            $(form).find('[name="field_pr_date_time_value[min]"]').val(minddate);
            $(form).find('[name="field_pr_date_time_value[max]"]').val(maxddate);
        }
        else
        {
            $(form).find('[name="field_pr_date_time_value[min]"]').val("");
            $(form).find('[name="field_pr_date_time_value[max]"]').val("");
        }



    },

    submitform: function(form){
        $(form).find(".button").click();

    },


    attach: function (context, settings) {


      once("prlistingform", "#views-exposed-form-media-view-page-1", context).forEach(function (form) {

        $(form)
        .find("[name=user_pricesensitive]")
        .click(function (el) {
            if (el.target.checked) {
              $("[name='field_pr_pricesensitive_value']").val("1");
            } else {
              $("[name='field_pr_pricesensitive_value']").val("All");
            }
            $(".path-pr-listing .views-exposed-form").find(".button").click();
            Drupal.behaviors.prlistingform.submitform(form);
        });

        if($(form).find('[name=year_select]').val() == 'all'){
            $(form).find('.form-item-month-select').hide();
        }
        else
        {
            $(form).find('.form-item-month-select').show();
        }

        const count = $("#total-count").html();
        $("#item-count").text(count);

        $(form).find('[name=year_select]').change(function(){
            Drupal.behaviors.prlistingform.setprlistingdatefilters(form);
            Drupal.behaviors.prlistingform.submitform(form);
        });
        $(form).find('[name=month_select]').change(function(){
            Drupal.behaviors.prlistingform.setprlistingdatefilters(form);
            Drupal.behaviors.prlistingform.submitform(form);
        });

      });

    },
  };
})(jQuery, Drupal, drupalSettings);
